import { IconButton, Tooltip } from "@material-ui/core";
import { columnTextField, columnNumberField } from "utils/tables-utils";
import { RequestPageOutlined } from "@mui/icons-material";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";

export default function TableTitulosEmAtraso({ data }) {
  const columnModel = [
    columnNumberField({
      dataField: "NumeroTitulo",
      text: "Nr. Título",
    }),
    columnTextField({
      dataField: "DataVencimento",
      text: "Vencimento",
    }),
    columnTextField({
      dataField: "DiasAtraso",
      text: "Dias em Atraso",
      headerAlign: "center",
      align: "center",
    }),
    columnTextField({
      dataField: "Valor",
      text: "Valor",
      formatter: (value) => (value ? `R$ ${value}` : ""),
    }),
    columnTextField({
      dataField: "actions",
      text: "",
      align: "center",
      formatter: (_, row) => {
        if (!row.UrlBoleto) {
          return null;
        }

        return (
          <Tooltip title="Visualizar Boleto">
            <IconButton
              size="small"
              onClick={() => {
                window.open(row.UrlBoleto, "_blank");
              }}
            >
              <RequestPageOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data || []}
      columnModel={columnModel}
      keyField="NumeroTitulo"
      pagination={{
        options: [10, 25, 50, 100],
        defaultOption: 10,
        totalSize: data.length,
        showTotal: true,
      }}
      style={{
        boxShadow: "none",
        margin: "0 -1rem",
      }}
    />
  );
}
